import React from 'react';
import { BaseTabViewProps } from './utils';
import { useIsMobileLayout } from '../../../hooks/useIsMobileLayout';
import TabView from './TabView';
import TabCardView from './SideTabView';

export type LayoutDependentTabViewOwnProps = BaseTabViewProps;

export type LayoutDependentTabViewProps = LayoutDependentTabViewOwnProps;

const LayoutDependentTabView: React.FC<LayoutDependentTabViewProps> = (props) => {
    const isMobile = useIsMobileLayout();
    return isMobile ? <TabView {...props} /> : <TabCardView {...props} />;
};

export default React.memo(LayoutDependentTabView);
